import React from 'react'
import fitnessSite from '../Assets/fitnessSite.png'
import micaelaSite from '../Assets/micaelaSite.png'
import htmlEmail from '../Assets/htmlEmail.png'





const Portfolio = () => {

  const portfolios = [
    {
      id: 1,
      src: fitnessSite,
      href: 'https://richardhorvatich.github.io/PersonalTraining/html%20site.html',
    },
    {
      id: 2,
      src: micaelaSite,
      href: 'https://richardhorvatich.github.io/MicaelaMathers/',
    },
    {
      id: 3,
      src: htmlEmail,
      href: 'https://richardhorvatich.github.io/HTML-Email-Fitness-Promotional/',
    },


  ]

  return (
    <div
    name="portfolio"
    className="bg-gradient-to-b from-black to-gray-800 w-full
    text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col 
      justify-center w-full h-full ">
        <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 
            border-gray-500"
            >
                Portfolio</p>
            <p className="py-6">A few recent projects below</p>
        </div>

        
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8
        px-12 sm:px-0 ">

          {portfolios.map(({id, src, href}) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
                <img 
                src={src} 
                alt="" 
                className="rounded-md duration-200 hover:scale-105"
                />
                <div className="flex items-center justify-center">
                    <a href={href} className="w-1/2 px-6 py-3 ml-9 pt-2 justify-center duration-200 hover:scale-105">Preview</a>
                    
                </div>
            </div>
          ))
        }
            
        </div>

      </div>
    </div>
  )
}

export default Portfolio
